import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    numero: '',
    fechaVencimientoInicial: moment.utc(new Date()).format('YYYY-MM-DD'),
    cantidadCuotas: 0,
    importe: 0,
    importeIntereses: 0,
    bancoCuentaId: 0,
    bancoCuenta: null,
    bancoCuentaNombre: null,
    /* Datos para la edicion del plan de pagos */
    proveedor: null,
    impuestoOrganismo: null,
    fechaCancelacion: '1900-01-01',
    rowVersion: null,
    
    cuotas: [],
    totales: [],
    importeCapital: 0,
    importeIntereses: 0,
    importeInteresesResarcitorios: 0,
    importeTotal: 0,

    planPagosDatos: [],
    planPagosCuotasDatos: [],
    planPagosPagoDatos: [],
};

const mutations = {
    updateField,

    'INICIALIZAR_PLAN_PAGOS'(state, planPagosId) {
        state.id= planPagosId;
        state.numero = ''; 
        state.fechaVencimientoInicial = moment.utc(new Date()).format('YYYY-MM-DD');
        state.cantidadCuotas = 0;
        state.importe = 0;
        state.importeIntereses = 0;
        state.bancoCuentaId = 0;
        state.bancoCuenta = null;
        state.bancoCuentaNombre = null;
        /* Datos para la edicion del plan de pagos */
        state.proveedor = null;
        state.impuestoOrganismo = null;
        state.fechaCancelacion = '1900-01-01';
        state.rowVersion = null;

        state.cuotas = [];
        state.totales = [];
        state.importeCapital = 0;
        state.importeIntereses = 0;
        state.importeInteresesResarcitorios = 0;
        state.importeTotal = 0;
    },
    'SET_PLAN_PAGOS'(state, planPagos) {
        state.numero = planPagos.numero; 
        state.cuotas = planPagos.cuotas;
        state.proveedor = planPagos.proveedor;
        state.impuestoOrganismo = planPagos.impuestoOrganismo;
        state.bancoCuentaNombre = planPagos.bancoCuenta;
        state.fechaCancelacion = moment.utc(planPagos.fechaCancelacion).format('YYYY-MM-DD');
        state.rowVersion = planPagos.rowVersion;

        state.cuotas.forEach(cuota => {
            cuota.fechaVencimiento = moment.utc(cuota.fechaVencimiento).format('YYYY-MM-DD');
        });

        calcularTotales(state);
    },
    'SET_BANCO_CUENTA'(state, bancoCuenta) {
        state.bancoCuentaId = bancoCuenta? bancoCuenta.id : 0;
        state.bancoCuenta = bancoCuenta;
        state.bancoCuentaNombre = bancoCuenta? bancoCuenta.nombre.trim() : null;
    },
    'CALCULAR_TOTALES'(state) {
        calcularTotales(state);
    },

    'INICIALIZAR_DATOS'(state) {
        state.planPagosDatos = [];
        state.planPagosCuotasDatos = [];
        state.planPagosPagoDatos = [];
    },
    'SET_DATOS'(state, params) {
        state.planPagosDatos = params.planPagosDatos;
        state.planPagosCuotasDatos = params.planPagosCuotasDatos.map(cuota => ({
            ...cuota,
            importeCapitalAdeudado: !cuota.capitalCancelado && !cuota.refinanciado,
            importeInteresesAdeudado: !cuota.interesesCancelado && !cuota.refinanciado && cuota.importeIntereses != 0,
            importeInteresesResarcitoriosAdeudado: !cuota.interesesResarcitoriosCancelado && !cuota.refinanciado && cuota.importeInteresesResarcitorios != 0
        }));
        state.planPagosPagoDatos = params.planPagosPagoDatos;
    },
};

function calcularTotales(state) {
    state.importeCapital = state.cuotas
        .reduce((total, cuota) => {
            return total + parseFloat(cuota.importeCapital)}, 0);

    state.importeIntereses = state.cuotas
        .reduce((total, cuota) => {
            return total + parseFloat(cuota.importeIntereses)}, 0);

    state.importeInteresesResarcitorios = state.cuotas
        .reduce((total, cuota) => {
            return total + parseFloat(cuota.importeInteresesResarcitorios)}, 0);

    state.importeTotal = parseFloat(state.importeCapital)
        + parseFloat(state.importeIntereses)
        + parseFloat(state.importeInteresesResarcitorios);
                
    state.totales = [];
    state.totales.push({
        totales: 'TOTALES',
        importeCapital: state.importeCapital,
        importeIntereses: state.importeIntereses,
        importeInteresesResarcitorios: state.importeInteresesResarcitorios
    })
}

const getters = {
    getField,

    planPagos (state) {
        return {
            numero: state.numero.toUpperCase().trim(),
            fechaVencimientoInicial: moment.utc(state.fechaVencimientoInicial).format('YYYY-MM-DD'),
            cantidadCuotas: parseInt(state.cantidadCuotas),
            importe: parseFloat(state.importe),
            importeIntereses: parseFloat(state.importeIntereses),
            bancoCuentaId: parseInt(state.bancoCuentaId)
        }
    }
};

const actions = {
    inicializar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PLAN_PAGOS');
            resolve();
        })
    },
    getPlanPagos ( { commit }, planPagosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PLAN_PAGOS', planPagosId);
            // resolve();

            let getPlan = false;
            if (planPagosId) {
                if (planPagosId != 0) {
                    getPlan = true;
                }
            }

            if (getPlan) {
                apiAxios.get(`planespagos/${planPagosId}/abm`) 
                    .then(res => {
                        commit('SET_PLAN_PAGOS', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            let cuotas = state.cuotas.map(cuota => ({
                id: cuota.id,
                fechaVencimiento: moment(cuota.fechaVencimiento).format('YYYY-MM-DD'),
                importeCapital: parseFloat(cuota.importeCapital),
                importeIntereses: parseFloat(cuota.importeIntereses),
                importeInteresesResarcitorios: parseFloat(cuota.importeInteresesResarcitorios),
            }))

            let planPagos = {
                numero: state.numero,
                cuotas,
                rowVersion: state.rowVersion
            }

            apiAxios.post(`planespagos/${state.id}`, planPagos)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    setBancoCuenta ( { commit }, bancoCuenta ) {
        commit('SET_BANCO_CUENTA', bancoCuenta);
    },
    calcularTotales ( { commit } ) {
        commit('CALCULAR_TOTALES');
    },
    
    getPlanPagosDatos ( { commit }, planPagosId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (planPagosId != 0) {
                apiAxios.get(`planespagos/${planPagosId}`) 
                .then(res => {
                    let planPagosDatos = [
                        { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': res.data.fechaRegistro, 'formato': 'fecha' },
                        { 'nombre': 'impuestoOrganismo', 'campo': 'Organismo', 'valor': res.data.impuestoOrganismo, 'formato': '' },
                        { 'nombre': 'proveedor', 'campo': 'Impuesto', 'valor': res.data.proveedor, 'formato': '' },
                        { 'nombre': 'numero', 'campo': 'Nro Plan', 'valor': res.data.numero, 'formato': '' },
                        { 'nombre': 'bancoCuenta', 'campo': 'Cuenta', 'valor': res.data.bancoCuenta, 'formato': '' },
                        { 'nombre': 'cantidadCuotas', 'campo': 'Cuotas', 'valor': res.data.cantidadCuotas, 'formato': '' },
                        { 'nombre': 'importe', 'campo': 'Importe', 'valor': res.data.importe, 'formato': 'moneda' },
                    ];

                    if (moment.utc(res.data.fechaCancelacion).format('YYYY-MM-DD') != '1900-01-01') {
                        planPagosDatos.push({ 'nombre': 'fechaCancelacion', 'campo': 'Cancelado', 'valor': res.data.fechaCancelacion, 'formato': 'fecha' })
                    }
                    if (moment.utc(res.data.fechaRefinanciacion).format('YYYY-MM-DD') != '1900-01-01') {
                        planPagosDatos.push({ 'nombre': 'fechaRefinanciacion', 'campo': 'Refinanciado', 'valor': res.data.fechaRefinanciacion, 'formato': 'fecha' })
                    }

                    let pagoDatos = [];

                    if (res.data.pago) {
                        const pago = res.data.pago;

                        let total = helpers.methods.formattedMoneda(pago.total, pago.moneda);
                        let saldo = helpers.methods.formattedMoneda(pago.saldo, pago.moneda);
    
                        pagoDatos = [
                            { 'nombre': 'fechaRegistro', 'campo': 'Fecha', 'valor': pago.fechaRegistro, 'formato': 'fecha' },
                            { 'nombre': 'impuestoOrganismo', 'campo': 'Organismo', 'valor': pago.impuestoOrganismo, 'formato': '' },
                            { 'nombre': 'proveedor', 'campo': 'Impuesto', 'valor': pago.proveedor, 'formato': '' },
                        ];

                        if (pago.planPagosId != 0) {
                            pagoDatos.push(
                                { 'nombre': 'planPagosNumero', 'campo': 'Nro.Plan de Pagos', 'valor': pago.planPagosNumero, 'formato': '' },
                            );
                        }

                        pagoDatos.push(
                            { 'nombre': 'total', 'campo': 'Total', 'valor': total, 'formato': '' },
                            { 'nombre': 'saldo', 'campo': 'Saldo', 'valor': saldo, 'formato': '' },
                            { 'nombre': 'observaciones', 'campo': 'Observaciones', 'valor': pago.observaciones.trim(), 'formato': '' },
                        );
                    }

                    let params =  {
                        planPagosDatos,
                        planPagosCuotasDatos: res.data.cuotas,
                        planPagosPagoDatos: pagoDatos
                    }
                    commit('SET_DATOS', params);
                    
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)))
            }
            resolve();
        }, error => {
            reject(error);
        })
    },    
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}